import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=302c3812&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302c3812",
  null
  
)

export default component.exports